require('angular').module('wowApp.shop')
    .service('ResetPasswordService', ['Restangular', require('./reset-password-service')])
    .directive('wowResetPassword', ['ResetPasswordService', '$state', 'PasswordValidationService', '$sce', require('./reset-password-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/resetpassword/index.js
 **/